import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_f_location_pin.svg'


const _hoisted_1 = {
  "data-testid": "pickup-detail-request-info",
  class: "w-full p-4 my-3 bg-white flex-col justify-start gap-3 inline-flex rounded-xl border border-gray-lp-1500"
}
const _hoisted_2 = {
  key: 0,
  "data-testid": "pickup-detail-request-info-skeleton",
  class: "w-full flex flex-col gap-2"
}
const _hoisted_3 = {
  "data-testid": "pickup-detail-request-info-title",
  class: "text-black-lp-100 text-base font-bold font-montserrat"
}
const _hoisted_4 = {
  key: 0,
  "data-testid": "pickup-detail-request-info-address-card",
  class: "flex-col w-full py-3 px-4 justify-start items-start gap-1 flex rounded-xl border border-gray-lp-1500"
}
const _hoisted_5 = {
  key: 0,
  "data-testid": "pickup-detail-request-info-address-header",
  class: "flex-row justify-start items-center gap-1 flex text-left w-full"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  class: "w-[18px] h-[18px]",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_7 = { class: "text-black-lp-100 text-sm font-medium font-montserrat" }
const _hoisted_8 = {
  key: 0,
  class: "text-black-lp-100 text-sm font-semibold font-montserrat"
}
const _hoisted_9 = {
  "data-testid": "pickup-detail-request-info-address-text",
  class: "w-full text-gray-lp-800 text-sm font-normal font-montserrat mt-0.5 whitespace-pre-line break-words"
}
const _hoisted_10 = {
  key: 1,
  "data-testid": "pickup-detail-request-info-coordinate",
  class: "w-full text-gray-lp-800 text-xs font-normal font-montserrat"
}
const _hoisted_11 = { class: "w-full text-black-lp-100 text-sm font-normal font-montserrat" }
const _hoisted_12 = {
  "data-testid": "pickup-detail-request-info-courier-note-label",
  class: "mb-2"
}
const _hoisted_13 = { class: "max-w-full overflow-hidden" }
const _hoisted_14 = {
  "data-testid": "pickup-detail-request-info-courier-note-value",
  class: "font-bold whitespace-pre-line break-all"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_skeleton = _resolveComponent("skeleton")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_skeleton, {
            width: "100%",
            height: "20px"
          }),
          _createVNode(_component_skeleton, {
            width: "90%",
            height: "20px"
          })
        ]))
      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("pickupV2.detail.requestInfo.sectionTitle")), 1),
          (_ctx.hasAddressData)
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                (!_ctx.isPcaEmpty)
                  ? (_openBlock(), _createBlock("div", _hoisted_5, [
                      _hoisted_6,
                      _createVNode("span", _hoisted_7, _toDisplayString(_ctx.pcaName), 1),
                      (_ctx.pcaContact)
                        ? (_openBlock(), _createBlock("span", _hoisted_8, " · " + _toDisplayString(_ctx.pcaContact), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_9, _toDisplayString(_ctx.pcaAddress), 1),
                (_ctx.pcaLatlon)
                  ? (_openBlock(), _createBlock("div", _hoisted_10, _toDisplayString(_ctx.$t("pickupV2.detail.requestInfo.coordinateLabel", {
              coordinate: _ctx.pcaLatlon
            })), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_11, [
            _createVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("pickupV2.detail.requestInfo.courierNoteLabel")), 1),
            _createVNode("div", _hoisted_13, [
              _createVNode("p", _hoisted_14, _toDisplayString(_ctx.getCourierNote), 1)
            ])
          ])
        ], 64))
  ]))
}